import { render, staticRenderFns } from "./goodsSelectComponent.vue?vue&type=template&id=6ae9338c&"
import script from "./goodsSelectComponent.vue?vue&type=script&lang=js&"
export * from "./goodsSelectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ae9338c')) {
      api.createRecord('6ae9338c', component.options)
    } else {
      api.reload('6ae9338c', component.options)
    }
    module.hot.accept("./goodsSelectComponent.vue?vue&type=template&id=6ae9338c&", function () {
      api.rerender('6ae9338c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/goods/goodsSelectComponent.vue"
export default component.exports